import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useFormState } from 'react-final-form';
import { Link } from 'react-router-dom';
import { ThreeDots } from 'react-loader-spinner';
import { useSelector } from 'react-redux';

import CommonButton from '../../components/common-button/CommonButton';
import { Input } from '../../components/common-inputs';
import WithLabel, { LABEL_STYLES } from '../../components/with-label/WithLabel';
import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import WithError from '../../components/with-error/WithError';
import PasswordInput from '../../components/common-inputs/PasswordInput';
import CommonCheckbox from '../../components/common-checkbox/CommonCheckbox';

import scss from '../Security.module.scss';

const LoginForm = ({ handleSubmit }) => {
  const { t } = useTranslation('securityPage');
  const isLoading = useSelector((state) => state.securityNew.isLoading);
  const { valid } = useFormState();

  return (
    <form className={scss.form} onSubmit={handleSubmit}>
      <h1 className={scss.title}>{t('signIn')}</h1>

      <div className={scss.items}>
        <Field name='username'>
          {({ meta, input }) => (
            <WithLabel variant={LABEL_STYLES.COLUMN} label={t('user')} extraClassName={scss.inputLabel}>
              <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)}>
                <Input
                  type='text'
                  placeholder={t('enterUserName')}
                  isError={meta.touched && meta.error}
                  formProps={input}
                  disabled={isLoading}
                  autoComplete='username'
                  LeftIcon={<Icon icon={ICONS.User} />}
                />
              </WithError>
            </WithLabel>
          )}
        </Field>

        <Field name='password' autoComplete='current-password'>
          {({ meta, input }) => (
            <WithLabel variant={LABEL_STYLES.COLUMN} label={t('password')} extraClassName={scss.inputLabel}>
              <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)}>
                <PasswordInput
                  placeholder={t('enterYourPassword')}
                  isError={meta.touched && meta.error}
                  formProps={input}
                  disabled={isLoading}
                  autoComplete='current-password'
                  LeftIcon={<Icon icon={ICONS.Lock} />}
                />
              </WithError>
            </WithLabel>
          )}
        </Field>
      </div>

      <div className={scss.actions}>
        <Field name='rememberMe' type='checkbox'>
          {({ input }) => (
            <div className={scss.rememberMe}>
              <CommonCheckbox checked={input.checked} onChange={input.onChange} disabled={isLoading} />
              <span>{t('rememberMe')}</span>
            </div>
          )}
        </Field>
        <Link to={'/forgot-password'} className={scss.forgotPassword}>
          {t('forgotPassword')}?
        </Link>
      </div>

      <div className={scss.buttons}>
        <CommonButton styleColor='primary' type='submit' maxWidth={190} disabled={!valid}>
          {isLoading ? <ThreeDots height={15} width={40} /> : null}
          {t('signIn')}
        </CommonButton>
      </div>
    </form>
  );
};

export default LoginForm;
